import { eventId, metaEventFor, metaParamsFor } from "./meta.js";

/** Eventos que o GA4 lê do objeto `ecommerce` da camada de dados. */
const ECOMMERCE = new Set([
  "view_item",
  "add_to_cart",
  "remove_from_cart",
  "view_cart",
  "begin_checkout",
  "add_shipping_info",
  "add_payment_info",
  "purchase",
]);

/** Executa o envio isolando falhas de cada destino (CA-16). */
function seguro(envio) {
  try {
    envio();
  } catch {
    // Tracker bloqueado ou com erro interno não pode interromper a loja.
  }
}

/** gtag.js presente na página? */
function temGtag(scope) {
  return typeof scope?.gtag === "function";
}

/**
 * Container do GTM presente? O gtag.js também cria `google_tag_manager`,
 * então só contam as chaves de container (`GTM-...`).
 */
function temGtm(scope) {
  return Array.isArray(scope?.dataLayer) &&
    Object.keys(scope?.google_tag_manager ?? {}).some((chave) =>
      chave.startsWith("GTM-")
    );
}

/** Meta Pixel presente na página? */
function temPixel(scope) {
  return typeof scope?.fbq === "function";
}

/**
 * Despacha um evento para os destinos presentes na página (CA-1, CA-17, CA-19).
 *
 * @param {string} name nome do evento no vocabulário GA4
 * @param {object} params parâmetros já montados (ver payload.js)
 * @param {object} [scope] globais injetáveis (default: globalThis)
 * @returns {void}
 */
export function track(name, params = {}, scope = globalThis) {
  const id = eventId(
    name,
    name === "purchase" ? params.transaction_id : undefined,
  );

  if (temGtag(scope)) {
    seguro(() => scope.gtag("event", name, params));
  }

  if (temGtm(scope)) {
    seguro(() => {
      if (ECOMMERCE.has(name)) {
        // Sem isto o objeto do evento anterior vaza para o próximo (CA-17).
        scope.dataLayer.push({ ecommerce: null });
        scope.dataLayer.push({ event: name, ecommerce: params });
      } else {
        scope.dataLayer.push({ event: name, ...params });
      }
    });
  }

  const eventoMeta = metaEventFor(name);
  if (eventoMeta && temPixel(scope)) {
    seguro(() =>
      scope.fbq("track", eventoMeta, metaParamsFor(name, params), {
        eventID: id,
      })
    );
  }
}
